
import { defineComponent, onMounted, reactive, toRefs } from "vue";
import { fetchManufacturingCompanies, postNewTurbineModel } from "@/helpers/api";
import { Companies } from "@/interfaces/systemsdb";

export default defineComponent({
  name: "NewTurbineModelModal",
  props: {
    selectedItem: {
      type: Object,
      required: true,
    },
  },
  emits: ["close", "save"],
  setup(props, { emit }) {
    const state = reactive({
      loading: false as boolean,

      saving: false as boolean,

      manufacturing_companies: [] as Companies[],
      design_companies: [] as Companies[],

      form: {
        gearbox: null as string | null,
        max_hub_height: null as string | null,
        max_rotor_speed: null as string | null,
        min_hub_height: null as string | null,
        min_rotor_speed: null as string | null,
        nacelle_weight: null as string | null,
        num_blades: "3",
        rated_wind_speed: null as string | null,
        rotor_diameter: null as string | null,
        rotor_weight: null as string | null,
        swept_area: null as string | null,
        total_weight: null as string | null,
        tower_weight: null as string | null,
        wind_class: null as string | null,
        name: null as string | null,
        power: null as string | null,
        offshore: false as boolean,
        designer: null as string | null,
        designer_id: null as number | null,
        manufacturer: null as number | null,
      },
      errorMsg: "" as string,
    });

    const loadOptions = async () => {
      state.loading = true;
      try {
        const [manufacturingCompaniesData, designCompaniesData] = await Promise.all([
          fetchManufacturingCompanies(),
          fetchManufacturingCompanies(),
        ]);

        state.manufacturing_companies = manufacturingCompaniesData;
        state.design_companies = designCompaniesData;
      } catch (error) {
        state.errorMsg = error instanceof Error ? error.message : "Failed to load options";
      } finally {
        state.loading = false;
      }
    };

    const save = async () => {
      state.errorMsg = "";
      state.saving = true;

      try {
        await postNewTurbineModel({ ...state.form });

        emit("save", {
          form: {
            ...state.form,
          },
        });

        emit("close");
      } catch (error) {
        state.errorMsg = error instanceof Error ? error.message : "Failed to save aggregator";
      } finally {
        state.saving = false;
      }
    };

    const close = () => {
      emit("close");
    };

    onMounted(loadOptions);

    return {
      ...toRefs(state),
      save,
      close,
    };
  },
});
